import { toast } from 'react-hot-toast';
import {dmApi} from "../../app/dmApi";
import {handleQueryErrorAndSuccess} from "../../helpers/RtkQueryUtils";

const authApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        getMe: build.query({
            query: () => ({
                url: "/auth/me",
                method: "GET",
            }),
            transformResponse: (response) => {
                const me = response?.data ?? response;
                return {
                    user: {
                        id: me?.id,
                        email: me?.email,
                        name: me?.name,
                        picture: me?.picture,
                    },
                    roles: me?.roles ?? [],
                };
            },
        }),
        loginUser: build.mutation({
            query: (request) => ({
                url: "/login",
                method: "POST",
                body: request,
            }),
            async onQueryStarted(_, {queryFulfilled}) {
                queryFulfilled.then(res => {
                    localStorage.setItem("authToken", res.data.token)
                }).catch(error => {
                    toast(error?.error?.data?.message, "error");
                })
            }
        }),
        forgotPassword: build.mutation({
            query: (request) => {
                return {
                    url: `/forgot-password`,
                    method: 'POST',
                    body: request,
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "", "A password reset email has been sent to the specified email address, if there is a user associated with it")
            },
        }),
    })
})
export const {
    useGetMeQuery,
    useLoginUserMutation,
    useForgotPasswordMutation
} = authApi;